import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RetailProductList, MarkAsFulfilledRequest } from '../models/retail-product.model';
import { environment } from '@fitness-force/environments';
import { AppErrors } from '@fitness-force/models';;
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class RetailProductService {
  private http = inject(HttpClient);


  /**
   * Get retail products for a client
   * @param clientId - The client ID
   * @returns Observable of RetailProductList
   */
  getRetailProducts(clientId: number): Observable<RetailProductList> {
    return this.http.get<RetailProductList>(`${environment.RETAIL_BILLING_URL}/clients/${clientId}/retail_products`).pipe(
    map((res: any) => res),
    catchError((error: any) => {
        return throwError(() => new AppErrors(error));
      })
    );
  }

  /**
   * Mark a retail product item as fulfilled
   * @param clientId - The client ID
   * @param orderItemId - The order item ID
   * @param request - The fulfilled quantity request
   * @returns Observable of any
   */
  markAsFulfilled(clientId: number, orderItemId: number, request: MarkAsFulfilledRequest): Observable<any> {
    return this.http.post<any>(`${environment.RETAIL_BILLING_URL}/clients/${clientId}/retail_orders/${orderItemId}/mark_as_fulfilled`, request).pipe(
      catchError((error: any) => {
          return throwError(() => new AppErrors(error));
        })
      );
  }


}
